import type { RenderData, RenderOptions } from '../assetTypes'
import { buildLearningTemplateHtml } from '../learning_templates/runtime'
import { collectLearningBatteryAssetReferences, resolveLearningBatteryDefinition } from './batteryDefinition'

const learningBatteriesRenderer = (content: string, options?: RenderOptions) => {
  const resolved = resolveLearningBatteryDefinition(content)
  const resolvedTemplate = options?.resolveAsset?.(resolved.root.template)

  if (!resolvedTemplate) {
    throw new Error(`Referenced learning template "${resolved.root.template}" is unavailable.`)
  }

  if (resolvedTemplate.assetType?.id !== 'learning_template') {
    const typeLabel = resolvedTemplate.assetType?.displayName ?? resolvedTemplate.assetType?.id ?? 'unknown'
    throw new Error(`Unit "${resolved.root.key}" must reference a Learning Template asset. Received "${typeLabel}".`)
  }

  if (!resolvedTemplate.content.trim()) {
    throw new Error(`Referenced learning template "${resolved.root.template}" has no text payload.`)
  }

  return buildLearningTemplateHtml(resolvedTemplate.content, { initialParams: resolved.root.params })
}

export const collectAssetReferences = (content: string, renderData?: RenderData) =>
  collectLearningBatteryAssetReferences(content, renderData)

export default learningBatteriesRenderer
